import React from 'react';
import { motion } from 'framer-motion';

const TeamSection = () => {
  const teamMembers = [
  {
    name: "Namory Traoré",
    role: "Fondateur & Directeur",
    description: "Visionnaire derrière ADT Express, connecte la diaspora depuis 2009",
    photo: "/assets/images/image-1772328678442.png",
    alt: "Portrait professionnel de Namory Traoré, fondateur et directeur d'ADT Express"
  },
  {
    name: "Fatou Koné",
    role: "Responsable Logistique",
    description: "Gère les départs et assure la ponctualité de chaque conteneur",
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1409ba06b-1772289779135.png",
    alt: "Portrait professionnel de Fatou Koné, responsable logistique, femme africaine souriante en tenue professionnelle"
  },
  {
    name: "Ibrahim Diallo",
    role: "Service Client",
    description: "À votre écoute 7j/7 pour répondre à toutes vos questions",
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_15a1e9e15-1773922015129.png",
    alt: "Portrait professionnel d'Ibrahim Diallo, responsable service client, homme africain avec casque téléphonique"
  },
  {
    name: "Marie Bamba",
    role: "Responsable Pro",
    description: "Accompagne les professionnels dans leurs envois de conteneurs complets",
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_17c736752-1763300698503.png",
    alt: "Portrait professionnel de Marie Bamba, responsable clientèle professionnelle, femme africaine souriante en costume d'affaires dans un bureau"
  }];


  return (
    <div className="py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12">
          
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            L'équipe ADT Express
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg">
            Des professionnels du transport maritime à votre service
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers?.map((member, index) =>
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
            
              {/* Photo */}
              <div className="relative h-48 bg-gradient-to-br from-green-100 to-green-50 flex items-center justify-center overflow-hidden">
                <img
                src={member?.photo}
                alt={member?.alt}
                className="w-full h-full object-cover"
                loading="lazy" />
              
              </div>

              {/* Content */}
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold text-slate-900 mb-1">
                  {member?.name}
                </h3>
                <p className="text-green-600 font-semibold mb-3">
                  {member?.role}
                </p>
                <p className="text-sm text-slate-600">
                  {member?.description}
                </p>
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </div>);









};

export default TeamSection;